const state = {
	users_index: {
		data: [],
		links: {},
		meta: {},
	},
};

export default state;
